import { Crop } from 'react-image-crop'

export function readImage(file: File | Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = () => reject(new Error('Failed to load image'))
      image.src = reader.result as string
    }

    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
}

export async function cropImage(image: HTMLImageElement, crop: Crop): Promise<[string, Blob]> {
  if (!crop.width || !crop.height) {
    throw new Error('Invalid crop dimensions')
  }

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d', { willReadFrequently: true })

  if (!ctx) {
    throw new Error('Could not get canvas 2d context')
  }

  const scaleX = image.naturalWidth / 100
  const scaleY = image.naturalHeight / 100

  canvas.width = crop.width * scaleX
  canvas.height = crop.height * scaleY

  ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height)

  try {
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('Canvas is empty'))), 'image/png', 1)
    })

    const croppedImage = await readImage(blob)

    return [croppedImage.src, blob]
  } catch (error) {
    throw new Error(`Failed to crop image: ${error instanceof Error ? error.message : String(error)}`)
  }
}

export const calculateProportionalDimensions = (naturalWidth: number, naturalHeight: number) => {
  const aspectRatio = naturalWidth / naturalHeight

  const maxWidth = 600
  const maxHeight = 400

  let displayWidth = naturalWidth
  let displayHeight = naturalHeight

  if (displayHeight > maxHeight) {
    displayHeight = maxHeight
    displayWidth = displayHeight * aspectRatio
  }

  if (displayWidth > maxWidth) {
    displayWidth = maxWidth
    displayHeight = displayWidth / aspectRatio
  }

  return {
    naturalWidth,
    naturalHeight,
    displayWidth: Math.round(displayWidth),
    displayHeight: Math.round(displayHeight),
    aspectRatio,
  }
}
